/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiCashJournal, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of CashJournalsController.
 */
export class CashJournalsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /cash_journals:prefill
     */
    public createPrefilled(): Promise<Result<ApiCashJournal>> {
        return this.http.post<Result<ApiCashJournal>, undefined>('/cash_journals:prefill', undefined);
    }

    /**
     * Calls GET /cash_journals:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiCashJournal>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiCashJournal>>>('/cash_journals:query', query);
    }

    /**
     * Calls POST /cash_journals:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiCashJournal>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCashJournal>>, ListRequest>('/cash_journals:query', listRequest, query);
    }

    /**
     * Calls POST /cash_journals:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiCashJournal>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCashJournal>>, ListRequestWithIds>('/cash_journals:batch', listRequest, query);
    }

    /**
     * Calls POST /cash_journals/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiCashJournal>>> {
        return this.http.post<Result<LockedContextDto<ApiCashJournal>>, undefined>(`/cash_journals/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /cash_journals/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiCashJournal>> {
        return this.http.post<Result<ApiCashJournal>, undefined>(`/cash_journals/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /cash_journals/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiCashJournal[]>> {
        return this.http.post<Result<ApiCashJournal[]>, string[]>('/cash_journals/locks', ids);
    }

    /**
     * Calls POST /cash_journals/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/cash_journals/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /cash_journals/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/cash_journals/${primaryId}/locks`);
    }

    /**
     * Calls GET /cash_journals/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiCashJournal>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiCashJournal>>(`/cash_journals/${primaryId}`, query);
    }

    /**
     * Calls POST /cash_journals
     */
    public add(dto: ApiCashJournal): Promise<Result<ApiCashJournal>> {
        return this.http.post<Result<ApiCashJournal>, ApiCashJournal>('/cash_journals', dto);
    }

    /**
     * Calls PUT /cash_journals/{primaryId}
     */
    public update(dto: ApiCashJournal, primaryId: string): Promise<Result<ApiCashJournal>> {
        return this.http.put<Result<ApiCashJournal>, ApiCashJournal>(`/cash_journals/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /cash_journals
     */
    public putRange(dtos: ApiCashJournal[]): Promise<Result<ApiCashJournal[]>> {
        return this.http.patch<Result<ApiCashJournal[]>, ApiCashJournal[]>('/cash_journals', dtos);
    }

    /**
     * Calls DELETE /cash_journals/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/cash_journals/${primaryId}`);
    }
}
